export const environment = {
  production: false,
  appUrl: '//devapp.cliquidity.co.uk',
  webUrl: '//dev.cliquidity.co.uk',
  googlePlacesApiKey: 'AIzaSyDqEJwbwmxYFMwlcVE9k-533ImGmuTKU4Q',
  env: 'dev'
};
